import styled from 'styled-components'
import { colors } from 'client/styles'

export const AdditionalFeesBase = styled.div`
  border-radius: 8px;
  border: 1px solid ${colors.grey4};
  color: ${colors.grey2};
  line-height: 1.4;
  padding-block: 16px;
  padding-inline: 16px;
`

export const Fees = styled.div`
  display: flex;
  justify-content: space-between;
`

export const NotIncluded = styled.p`
  font-size: 12px;
  margin-block-end: 12px;
`

export const PricesWrapper = styled.span`
  padding-block: 0;
  padding-inline: 4px;
`
